import React, { useState, useEffect } from 'react'
import ClientService from "../../services/clients"
import PlaceIcon from '@material-ui/icons/Place'
import InfoIcon from '@material-ui/icons/Info';

import { Dialog, DialogTitle, DialogContent } from '@material-ui/core';
export default function Info(props) {
    const [client, setClient] = useState();
    const [project, setProject] = useState();
    const [showPopup, setShowPopup] = useState(false);

    useEffect(() => {
        if(props.client._id){
            setClient(props.client)
        }else{
            ClientService.get(props.client).then(
                (result) => { setClient(result) },
                (err) => { console.log(err) })
        }
        setProject(props.project);
    }, [props.project,props.client]);

    return (
        <React.Fragment>
             {(client && showPopup ) && <Dialog open={showPopup} onClose={() => { setShowPopup(false) }} aria-labelledby="dialog-title">
              
                <DialogContent>
                        <b>Klant : {client.name}</b><br/>
                         {client.address}<br/>
                         {client.pobox}, {client.town} {client.address && <a href={'https://www.google.nl/maps/dir//' + client.address.replace(/\s/g,'+') + ',' + client.town.replace(/\s/g,'+')} target="_blank" rel="noopener noreferrer"><PlaceIcon/></a>}<br/><br/>
                         {client.contactperson}<br/>
                         {client.phone && <a href={'tel:'+client.phone}>{client.phone}</a>}<br/><br/>
                         {client.mobile && <a href={'tel:'+client.mobile}>{client.mobile}</a>}<br/><br/>
                         {client.email && <a href={'mailto:'+client.email}>{client.email}</a>}<br/><br/>

                        <br/>
                        {project && <span>
                            <b>Project : {project.projectnumber} - {project.name}</b><br/>
                            {project.description}<br/>
                            {project.purchesorders && <span>Inkoopnummers: {project.purchesorders}</span>}<br/>
                        </span>}
                        
                </DialogContent>
            </Dialog>}
            {client && <span style={{cursor:'pointer'}} onClick={()=>{setShowPopup(true)}}>
                {client.name}, {client.town} <InfoIcon fontSize={'small'}/>
            </span>}

        </React.Fragment>
    )
}
